import { Link } from "react-router-dom";
import Logo from "./Logo";

const shop = [
  { to: "/boutique", label: "Boutique" },
  { to: "/panier", label: "Panier" },
  { to: "/admin", label: "Espace admin" },
];

const help = [
  { to: "/livraison", label: "Livraison" },
  { to: "/retours", label: "Retours" },
  { to: "/contact", label: "Contact" },
];

const legal = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/confidentialite", label: "Confidentialité" },
];

const Footer = () => (
  <footer className="border-t border-line bg-ink" data-testid="site-footer">
    <div className="px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-6 max-w-sm text-sm text-neutral-400 leading-relaxed">
          Streetwear premium pensé pour la rue. Pièces monochromes, matière lourde, coupes oversize — du XS au 4XL.
        </p>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-500">
          Paiement sécurisé Stripe · Données bancaires jamais stockées
        </p>
      </div>
      {[
        { title: "Boutique", items: shop },
        { title: "Aide", items: help },
        { title: "Légal", items: legal },
      ].map((col) => (
        <div key={col.title} className="md:col-span-2">
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">{col.title}</h4>
          <ul className="mt-5 space-y-3">
            {col.items.map((l) => (
              <li key={l.to + l.label}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-neutral-300 hover:text-white transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-line px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-500">© {new Date().getFullYear()} Moha66 — Tous droits réservés</p>
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-600">Du 66 pour le monde</p>
    </div>
  </footer>
);

export default Footer;
